import React from 'react';

import './MusicianListing.css';

export interface MusicianListingProps {
  name: string;

  imageUrl?: string;
  onClick?: () => void;
}

export const MusicianListing: React.FC<MusicianListingProps> = ({
  name,

  imageUrl,
  onClick,
}) => {
  const displayImage = imageUrl || '/images/avatar.svg';

  return (
    <div className="musician-listing" onClick={onClick}>
      <div className="musician-listing__image">
        <img src={displayImage} alt="" />
      </div>
      <div className="musician-listing__content">
        <h3 className="musician-listing__name">{name}</h3>

      </div>
    </div>
  );
};
